import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import NoRecordFound from '../../../components/common/no-record-found';

const PaymentCollectionMIS = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/api/report/payment-collection-mis`, { credentials: 'include' });
        if (!res.ok) throw new Error('Failed to fetch');
        const result = await res.json();
        setData(result.data || []);
      } catch (err) {
        setError('Failed to load payment collection MIS');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatNumber = (value) => {
    if (value === null || value === undefined) return '0.00';
    return parseFloat(value).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return dateString;
  };

  return (
    <div className="max-w-8xl mx-auto p-6 bg-white shadow-sm border border-gray-100">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Payment Collection MIS</h2>
          <p className="text-sm text-gray-500 mt-1">Summary of contract-wise payment collection</p>
        </div>
      </div>
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12 space-y-3">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600"></div>
          <p className="text-sm text-gray-600">Loading payment collection MIS...</p>
        </div>
      ) : error ? (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-lg">
          <h3 className="text-sm font-medium text-red-800">Error loading data</h3>
          <p className="text-sm text-red-700 mt-1">{error}</p>
        </div>
      ) : data.length === 0 ? (
        <NoRecordFound message="No records found" subMessage="No data available for the selected criteria" iconClass="text-gray-400" />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-xs">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50 text-gray-700 font-semibold">
              <tr>
                <th className="px-4 py-2 text-left">Contract No.</th>
                <th className="px-4 py-2 text-left">Buyer</th>
                <th className="px-4 py-2 text-right">Total Invoice</th>
                <th className="px-4 py-2 text-right">Late Charges</th>
                <th className="px-4 py-2 text-right">Received Payment</th>
                <th className="px-4 py-2 text-right">Balance Due</th>
                <th className="px-4 py-2 text-left">Last Payment Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {data.map((row, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-3 font-medium">{row.contract_no || '-'}</td>
                  <td className="px-4 py-3">{row.buyer || '-'}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{formatNumber(row.total_invoice)}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{formatNumber(row.late_charges)}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{formatNumber(row.received_payment)}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{formatNumber(row.balance_due)}</td>
                  <td className="px-4 py-3">{formatDate(row.last_payment_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentCollectionMIS;
